<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
  (onRefresh)="onReset()"
>
  <div class="card-toolbar" after-btns>
    <!-- excel btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>

    <!-- back btn -->
    <div [matTooltip]="'common.back' | translate">
      <a
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        mat-ripple
        [matTooltip]="'common.back' | translate"
        (click)="onBack()"
      >
        <i class="mdi mdi-arrow-left mdi-20px tw-p-0"></i>
      </a>
    </div>
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- senderMobile -->
        <td>
          <td-value copyToClipboard [value]="item?.senderMobile"></td-value>
        </td>

        <!-- privateNumber -->
        <td>
          <td-value copyToClipboard [value]="item?.privateNumber"></td-value>
        </td>

        <!-- smsText -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.smsText"
          ></td-value>
        </td>

        <!-- dateTimeReceive -->
        <td>
          <td-value type="dateTime" [value]="item?.dateTimeReceive"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>
